import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import logo32x37 from "../../static/images/logo32x37.png";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";

class PublicTopBarView extends React.Component {


    handleBrandClick = () => {
        EventPublisher.publish(UIInteractionEvents.PUBLIC_NAV_BRAND_CLICKED, {});
    };

    handleLoginClick = () => {
        EventPublisher.publish(UIInteractionEvents.PUBLIC_NAV_LOGIN_BUTTON_CLICKED, {});
    };

    render() {
        return(
            <nav className="navbar fixed-top navbar-expand-lg navbar-light bg-light border-bottom-box">
                <button type="button" onClick={this.handleBrandClick} className="btn btn-link navbar-brand">
                    <img src={logo32x37} className="rounded mr-2" alt="Cuvered Logo"/>
                    <span className="brand-text">Cuvered</span>
                </button>
                <button type="button" onClick={this.handleLoginClick} className="btn btn-cuvered-pink ml-auto">
                    <i className="fas fa-sign-out-alt mr-1"/>
                    Register / Login
                </button>
            </nav>
        );
    }
}

export default PublicTopBarView;